import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class CreateXMLFromInvoice {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(inv_id, filename): Promise<any> {
    let args = { 
      inv_id: inv_id
    }
    let res = await this.dispatcher.dispatch('create.xml.from.invoice', args)
    if(res.output['error']){
        this.frontend.message='Algo ha ido mal';
        this.frontend.show_message=true;
        console.error(res.output['error']);
        }
    else{
        const url = res.output['url'];
        const response = await fetch(url);    
        const blob = await response.blob();    
        const newBlob = new Blob([blob]);
        // For other browsers: create a link pointing to the ObjectURL containing the blob.      
        const objUrl = window.URL.createObjectURL(newBlob);      
        const link = document.createElement("a");      
        link.href = objUrl;      
        link.download = filename;      
        link.click();      
        // For Firefox it is necessary to delay revoking the ObjectURL.      setTimeout(() => {        
        setTimeout(() => {        
            window.URL.revokeObjectURL(objUrl);      
            }, 250);    
        }
  }
}